import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
interface PdfDisclaimersProps {
  applicantId: string
  caseId: string
  nameOnDocument: string
  dateOfBirth: string
  gender: string
}

export const PdfInformation: React.FC<PdfDisclaimersProps> = (props) => {
  const styles = StyleSheet.create({
    text: {
      fontSize: "7.5px",
      fontFamily: "Libre Franklin Bold"
    },
    subText: {
      fontSize: "6.5px",
      fontFamily: "Libre Franklin"
    },
    leftColumn: {
      flexDirection: "row",
      paddingRight: 20,
      paddingLeft: 5,
      paddingTop: 10,
    },
    row: {
      width: "100%",
    },
    label: {
      flexDirection: "row",
      alignItems: "center",
    },
  });

  return (
    <>
      <View style={styles.leftColumn}>
        <View style={styles.row}>
          <View style={{flexDirection: 'row'}}>
            <Text style={[styles.text, {width: 52}]}>Name: &nbsp; </Text>
            <Text style={[styles.subText, {width: 295, marginTop: 1, marginRight: 29}]}>{props.nameOnDocument}</Text>
          </View>
          <View style={styles.label}>
            <Text style={styles.text}>Date of Birth: &nbsp; </Text>
            <Text style={styles.subText}>{props.dateOfBirth}</Text>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.label}>
            <Text style={styles.text}>Gender: &nbsp; </Text>
            <Text style={styles.subText}>{props.gender}</Text>
          </View>
        </View>
      </View>

      <View style={[styles.text, { flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap', alignItems: 'center', paddingTop: 10, paddingLeft: 5 }]}>
      <Text style={[styles.text]}>
          IMPORTANT NOTE:
        </Text>
        <Text style={[styles.subText]}>
          {' '}When completed and submitted to Intealth this Identification Form
          will become part of your permanent record. All information on the 
        </Text>
        <Text style={[styles.subText]}>
        Identification Form is subject to verification and acceptance by Intealth.
        </Text>
      </View>
      
    </>
  );
};
export default PdfInformation;
